/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


 $(document).on('click','.ctm_add_cart',function(e){
        e.preventDefault();
        var form = $(this).closest('form');
    $(this).text('Adding...');
        $(this).addClass('prod_adding');
        var price = $(this).data('price');
        var splt_last_price = parseInt(price.split('.')[1]);
        if(splt_last_price > 0){
           
        }else{
          price = $(this).data('price').split('.')[0];
        }
        form.find('.err_msg').remove();
        var _this = $(this);
        $.ajax({
          method: "post",
          url: "/cart/add.js",
          data: form.serialize(),
          dataType: "json",
          success: function(data){
            console.log(data);
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: form.find('[name=id]').val(),
                quantity: parseInt(form.find('[name="quantity"]').val())
              }
            }))
//             _this.text('Thank you!');
            _this.removeClass('prod_adding');
            _this.addClass('prod_addded');
            setTimeout(function(e){
             
              _this.removeClass('prod_addded');
            },2000)
          },
          error: function(err){
            var err_msg = err.responseJSON.description
            form.append('<p class="err_msg">'+err_msg+'</p>');
           
            _this.removeClass('prod_addded prod_adding');
            setTimeout(function(e){
              form.find('.err_msg').remove();
            },2000)
          }
        })
		return false;
      })


$(document).ready(function () {
  $("#expandbtn").click(function () {
    if ($("#content-pro").hasClass("readmore")) {
      $("#expandbtn").html("Read More");
      $("#content-pro").removeClass("readmore");
    } else {
      $("#expandbtn").html("Read Less");
      $("#content-pro").addClass("readmore");
    }
  });
});


